module.exports = __webpack_public_path__ + "static/media/AIUB.ac70cced.jpg";